<span>

	<pen-pattern-viewer [width]="200" [height]="25"
						[lineColor]="lineColor" [lineWidth]="lineWidth"
						[lineDashStyle]="lineDashStyle">
	</pen-pattern-viewer>

	<button type="button" (click)="overlay.toggle($event)" pButton icon="fa fa-edit" label="Edit" [disabled]="!isLicenseValid"
			style="top: -8px; margin-left: 15px;"></button>

	<p-overlayPanel #overlay [showCloseIcon]="true">
		<pen-pattern-editor [(lineColor)]="lineColor" 
							[(lineWidth)]="lineWidth"
							[(lineDashStyle)]="lineDashStyle"
							(lineColorChange)="onLineColorChange($event)"
							(lineDashStyleChange)="onLineDashStyleChange($event)"
							(lineWidthChange)="onLineWidthChange($event)">
		</pen-pattern-editor>
	</p-overlayPanel>

</span>
